module.exports = __webpack_public_path__ + "static/media/settings.2f2d412c.svg";